import { ChevronRight, Edit, Email, Phone, PhoneAndroid } from '@mui/icons-material';
import { Button, FormControlLabel, List, ListItem, ListItemText, Switch, TextField, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { AppModels, AppState, ContactAttrs, Lang, RelatedContactAttrs, hasErrors, notEmptyString, relatedContactSlice, saveModel, selectRelatedContacts } from 'cdx-common';
import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { appStore } from '../../store';
import { AppItem, ContactLoader } from '../AppItems';

const ContactSecondaryText = (props: {
    contact: ContactAttrs,
    relatedContact: RelatedContactAttrs,
    mainContactId?: ModelId | null,
    onMainCOntactToggle?: (relatedContactId: ModelId) => any;
}) => {

    const [relatedContact, setRelatedContact] = React.useState(props.relatedContact);
    const [editLabel, setEditLabel] = React.useState(false);

    React.useEffect(() => {
        setRelatedContact(props.relatedContact);
        setEditLabel(false);
    }, []);

    const save = async (changes?: RelatedContactAttrs) => {
        const response = await saveModel(AppModels.relatedContacts, changes ?? relatedContact);
        setRelatedContact(response);
        if (!hasErrors(response)) {
            appStore.dispatch(relatedContactSlice.actions.upsertOne(response));
        }

    };

    const onTitleBlur = () => {
        if (relatedContact.label !== props.relatedContact.label) {
            save();
        }
        setEditLabel(false);
    };

    const onSiteContactChanged = async () => {
        const changes: RelatedContactAttrs = {
            ...relatedContact,
            onSiteContact: !relatedContact.onSiteContact
        };
        setRelatedContact(changes);

        void save(changes);

    };


    const labelTextfield = () => <TextField
        fullWidth
        autoFocus
        error={!!relatedContact.__errors?.label}
        helperText={relatedContact.__errors?.label}
        variant='standard'
        size='small'
        inputProps={{
            style: { fontSize: 10, lineHeight: 10 }
        }}
        value={relatedContact.label}
        onChange={event => {
            setRelatedContact(e => {
                return {
                    ...e,
                    label: event.target.value
                };
            });
        }}
        onBlur={onTitleBlur}
        placeholder={Lang('lables.relatedContacts.label')} />;

    return <Box sx={{ paddingRight: '20px' }}>
        <Box>
            {editLabel ? labelTextfield() : <Typography variant='subtitle1' fontSize={12}>{notEmptyString(props.relatedContact.label) ?? <em>{Lang('lables.relatedContacts.label') + ' non spécifié'}</em>} <Edit style={{ fontSize: '12px' }} onClick={() => { setEditLabel(true); }} /></Typography>}
        </Box>
        <Box>
            <Box>{props.contact.email ? <a href={'mailto:' + props.contact.email}><Email style={{ fontSize: '14px' }} /> {props.contact.email}</a> : null}</Box>
            <Box>{props.contact.cell ? <><PhoneAndroid style={{ fontSize: '14px' }} /> {props.contact.cell}</> : null}</Box>
            <Box>{props.contact.tel ? <><Phone style={{ fontSize: '14px' }} /> {props.contact.tel}</> : null}</Box>
            <Box>
                <FormControlLabel control={<Switch size='small' checked={props.relatedContact.onSiteContact === true} onChange={onSiteContactChanged} />} label="Contact de chantier" />
                {props.mainContactId !== undefined && props.onMainCOntactToggle ? <FormControlLabel control={<Switch size='small' checked={props.relatedContact.id === props.mainContactId} onChange={() => { props.onMainCOntactToggle && props.onMainCOntactToggle(props.relatedContact.id); }} />} label="Contact principal" /> : null}
            </Box>
        </Box>
    </Box>;
};

export const RelatedContactList = (props: {
    type: AppModels,
    id: ModelId,
    mainContactId?: ModelId | null,
    onMainCOntactToggle?: (relatedContactId: ModelId) => any;
}) => {

    const relatedContacts = useSelector((state: AppState) => selectRelatedContacts(state, props.type, props.id));



    return <List>
        {relatedContacts.length === 0 ? <ListItem><ListItemText primary='Aucun' /></ListItem> : null}
        {relatedContacts.map(rc => <ListItem
            divider
            key={rc.id}
            secondaryAction={<Button component={Link} to={'/contact/' + rc.contactId}>
                <ChevronRight />
            </Button>}>
            <ContactLoader id={rc.contactId} render={contact => <ListItemText
                primary={<><AppItem mode='compact' type={AppModels.contacts} id={rc.contactId} /></>}
                secondary={<ContactSecondaryText contact={contact} relatedContact={rc} mainContactId={props.mainContactId} onMainCOntactToggle={props.onMainCOntactToggle} />}
            />}>
            </ContactLoader>
        </ListItem>
        )}
    </List>;
};
